<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 80vw">
      <div class="modal-header">
        <h3>{{ editingRecord ? "Edit" : "Add" }} Oncology Visit</h3>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="saveRecord">
          <div class="form-grid">
            <div class="form-group">
              <label>Visit Date *</label>
              <input type="datetime-local" v-model="form.visit_date" required class="form-control" />
            </div>

            <div class="form-group ">
              <label>Cancer Type *</label>
              <input type="text" v-model="form.cancer_type" required class="form-control" />
            </div>

            <div class="form-group ">
              <label>Primary Site</label>
              <input type="text" v-model="form.primary_site"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>Stage</label>
              <input type="text" v-model="form.stage" placeholder="e.g. Stage IIB, T2N1M0"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>Treatment Phase</label>
              <select v-model="form.treatment_phase"  class="form-control">
                <option value="">Select</option>
                <option value="Diagnosis">Diagnosis</option>
<option value="Active treatment">Active treatment</option>
<option value="Surveillance">Surveillance</option>
<option value="Palliative">Palliative</option>
<option value="Remission">Remission</option>
              </select>
            </div>

            <div class="form-group ">
              <label>Treatment Modality</label>
              <select v-model="form.treatment_modality"  class="form-control">
                <option value="">Select</option>
                <option value="Chemotherapy">Chemotherapy</option>
<option value="Radiotherapy">Radiotherapy</option>
<option value="Surgery">Surgery</option>
<option value="Combination">Combination</option>
<option value="Palliative care">Palliative care</option>
              </select>
            </div>

            <div class="form-group ">
              <label>Performance Status (ECOG)</label>
              <select v-model="form.performance_status"  class="form-control">
                <option value="">Select</option>
                <option value="ECOG 0">ECOG 0</option>
<option value="ECOG 1">ECOG 1</option>
<option value="ECOG 2">ECOG 2</option>
<option value="ECOG 3">ECOG 3</option>
<option value="ECOG 4">ECOG 4</option>
              </select>
            </div>

            <div class="form-group ">
              <label>Current Cycle</label>
              <input type="text" v-model="form.current_cycle"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>Next Cycle Date</label>
              <input type="date" v-model="form.next_cycle_date"  class="form-control" />
            </div>

            <div class="form-group ">
              <label>Weight (kg)</label>
              <input type="number" v-model="form.weight_kg" step="0.1"  class="form-control" />
            </div>

            <div class="form-group full-width">
              <label>Symptoms</label>
              <textarea v-model="form.symptoms" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group full-width">
              <label>Side Effects</label>
              <textarea v-model="form.side_effects" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group full-width">
              <label>Complications</label>
              <textarea v-model="form.complications" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group full-width">
              <label>Plan</label>
              <textarea v-model="form.plan" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group full-width">
              <label>Notes</label>
              <textarea v-model="form.notes" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-group ">
              <label>Seen By</label>
              <input type="text" v-model="form.seen_by"  class="form-control" />
            </div>
          </div>

          <div class="modal-actions">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cancel</button>
            <button type="submit" class="btn btn-primary" :disabled="saving">
              {{ saving ? "Saving..." : (editingRecord ? "Update" : "Save") + " Visit" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";

export default {
  name: "OncologyVisitModal",
  props: {
    visitId: { type: [Number, String], default: null },
    editRecord: { type: Object, default: null },
  },
  data() {
    return {
      saving: false,
      editingRecord: null,
      form: this.emptyForm(),
    };
  },
  created() {
    if (this.editRecord) {
      this.editingRecord = this.editRecord;
      this.form = {
        ...this.emptyForm(),
        ...this.editRecord,
        visit_date: this.toLocalDateTime(this.editRecord.visit_date),
      };
    }
  },
  methods: {
    emptyForm() {
      return {
        visit_date: this.toLocalDateTime(new Date()),
        cancer_type: "",
        primary_site: "",
        stage: "",
        treatment_phase: "",
        treatment_modality: "",
        performance_status: "",
        current_cycle: "",
        next_cycle_date: "",
        weight_kg: "",
        symptoms: "",
        side_effects: "",
        complications: "",
        plan: "",
        notes: "",
        seen_by: ""
      };
    },
    toLocalDateTime(value) {
      if (!value) return "";
      const d = new Date(value);
      if (isNaN(d.getTime())) return "";
      const pad = (n) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    closeModal() {
      this.$emit("close");
    },
    async saveRecord() {
      this.saving = true;
      try {
        const payload = { ...this.form, visit_id: this.visitId };
        let response;
        if (this.editingRecord) {
          response = await generalApiRequest(`oncology_visits/${this.editingRecord.id}`, "PUT", payload, 1);
        } else {
          response = await generalApiRequest("oncology_visits", "POST", payload, 1);
        }
        if (response.success) {
          this.$emit("saved", response.data);
          this.closeModal();
        } else {
          alert(response.message || "Failed to save record");
        }
      } catch (error) {
        console.error("Error saving record:", error);
        alert("An error occurred while saving");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.mmodal-content { background: white; border-radius: 10px; max-height: 90vh; overflow-y: auto; display: flex; flex-direction: column; }
.modal-header { padding: 20px; background: linear-gradient(135deg, #805ad5 0%, #553c9a 100%); color: white; display: flex; justify-content: space-between; align-items: center; }
.modal-header h3 { margin: 0; font-size: 20px; }
.close { background: rgb(233, 22, 22); border: 1px solid rgb(182, 178, 178); font-size: 1.5rem; color: white; line-height: 1; cursor: pointer; }
.modal-body { padding: 30px; overflow-y: auto; flex-grow: 1; }
.form-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; margin-bottom: 20px; }
.form-group { margin-bottom: 15px; }
.form-group.full-width { grid-column: 1 / -1; }
.form-group label { display: block; margin-bottom: 5px; font-weight: 600; color: #495057; }
.checkbox-label { display: flex !important; align-items: center; gap: 8px; margin-top: 28px; }
.form-control { width: 100%; padding: 10px; border: 1px solid #ddd; border-radius: 5px; font-size: 14px; }
.modal-actions { display: flex; justify-content: flex-end; gap: 15px; }
.btn { padding: 10px 25px; border: none; border-radius: 5px; cursor: pointer; font-weight: 600; }
.btn-secondary { background: #6c757d; color: white; }
.btn-secondary:hover { background: #5a6268; }
.btn-primary { background: #553c9a; color: white; }
.btn-primary:hover { opacity: 0.9; }
.btn-primary:disabled { opacity: 0.6; cursor: not-allowed; }
@media (max-width: 1200px) { .form-grid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 768px) { .form-grid { grid-template-columns: 1fr; } }
</style>
